<template>
  <div>
    <v-list-item v-if="unit.urlRef" :disabled="!isPreSurveyFinished" @click="goUrl(`${unit.urlRef}`)">
      <v-list-item-avatar>
        <v-icon color="grey lighten-1">
          mdi-web
        </v-icon>
      </v-list-item-avatar>
      <v-list-item-content class="text-left">
        <v-list-item-title class="wrap-text mt-2" v-text="`${unit.lessonTitle}`" />
        <v-list-item-subtitle class="wrap-text" v-text="`${unit.notice}`" />
      </v-list-item-content>
    </v-list-item>
    <v-list-item v-else-if="unit.isReference" :disabled="!isPreSurveyFinished" @click="downloadFile($event, unit)">
      <v-list-item-avatar>
        <v-icon color="grey lighten-1">
          mdi-file-outline
        </v-icon>
      </v-list-item-avatar>
      <v-list-item-content class="text-left">
        <v-list-item-title class="wrap-text mt-2" v-text="formattedTitle" />
        <v-list-item-subtitle v-if="unit.notice" class="wrap-text" v-text="`${unit.notice}`" />
      </v-list-item-content>
    </v-list-item>
    <v-list-item v-else-if="unit.unitTitle==='受講前アンケート'&&unit.isSurvey" :disabled="hasFinished(unit.unitTitle)" @click="goSurvey(unit.unitTitle)">
      <v-list-item-avatar>
        <v-icon color="grey lighten-1">
          mdi-content-paste
        </v-icon>
      </v-list-item-avatar>
      <v-list-item-content class="text-left">
        <v-list-item-title class="wrap-text mt-2" v-text="`${unit.unitTitle}`" />
        <v-list-item-subtitle v-if="hasFinished(unit.unitTitle)" class="wrap-text" v-text="`回答済み`" />
      </v-list-item-content>
    </v-list-item>
    <v-list-item v-else-if="unit.unitTitle==='受講後アンケート'&&unit.isSurvey" :disabled="hasFinished(unit.unitTitle)||!isPreSurveyFinished" @click="goSurvey(unit.unitTitle)">
      <v-list-item-avatar>
        <v-icon color="grey lighten-1">
          mdi-content-paste
        </v-icon>
      </v-list-item-avatar>
      <v-list-item-content class="text-left">
        <v-list-item-title class="wrap-text mt-2" v-text="`${unit.unitTitle}`" />
        <v-list-item-subtitle v-if="hasFinished(unit.unitTitle)" class="wrap-text" v-text="`回答済み`" />
      </v-list-item-content>
    </v-list-item>
    <v-list-item v-else :disabled="!isPreSurveyFinished" @click="goLesson(`${unit.systemUnitNumber}/lesson-list`)">
      <v-list-item-avatar>
        <v-icon v-if="unit.isIntroduction" color="grey lighten-1">
          mdi-leaf
        </v-icon>
        <v-icon v-else-if="qualifyList[`${unit.systemUnitNumber}`-1] === 1" color="green darken-2">
          mdi-checkbox-marked-circle
        </v-icon>
        <v-icon v-else-if="qualifyList[`${unit.systemUnitNumber}`-1] === 2" color="red darken-2">
          mdi-close-circle
        </v-icon>
        <v-icon v-else color="grey lighten-1">
          mdi-circle-outline
        </v-icon>
      </v-list-item-avatar>
      <v-list-item-content class="text-left">
        <v-list-item-title class="wrap-text mt-2" v-text="formattedTitle" />
      </v-list-item-content>
    </v-list-item>
  </div>
</template>

<script>
export default {
  props: {
    unit: {
      type: Object,
      required: true
    },
    isPreSurveyFinished: {
      type: Boolean,
      required: true
    },
    isPostSurveyFinished: {
      type: Boolean,
      required: true
    },
    qualifyList: {
      type: Array,
      required: true
    }
  },
  computed: {
    formattedTitle: function () {
      if (this.unit.unitNumber === null) return `${this.unit.unitTitle}`

      return `${this.unit.unitNumber}： ${this.unit.unitTitle}`
    }
  },
  mounted: async function () {
  },
  methods: {
    async downloadFile (e, unit) {
      e.preventDefault()
      for await (const courseMaterial of unit.courseMaterialRef) {
        const link = document.createElement('a')
        link.href = require('@/assets/courseMaterials/' + this.$route.params.courseId + '/' + courseMaterial)
        link.download = courseMaterial
        link.click()
      }
    },
    goLesson: function (title) {
      this.$router.push(title)
    },
    goSurvey: function (title) {
      if (title === '受講前アンケート') {
        this.$router.push('survey/pre')
      } else {
        this.$router.push('survey/post')
      }
    },
    goUrl: function (title) {
      window.open(title)
    },
    hasFinished: function (title) {
      if (title === '受講前アンケート') {
        return this.isPreSurveyFinished
      } else {
        return this.isPostSurveyFinished
      }
    }
  }
}
</script>

<style scoped>
.wrap-text {
  word-break: break-all;
  white-space: normal;
}
</style>
